// import React, { useState, useContext } from 'react'
// import { useForm } from 'react-hook-form'
// import { useTranslation } from 'react-i18next'
// import useToastContext from 'hooks/useToastContext'
// import AuthContext from 'context/AuthContext'
// import { apiPost } from 'utils/apiFetch'
// import apiPath from 'utils/pathObj'
// import ErrorMessage from 'components/ErrorMessage'
// import OInputField from 'components/reusable/OInputField'
// import formValidation from 'utils/formValidation'

// const AddOnboarding = ({ getForms , closeModal }) => {
//   const { t } = useTranslation()
//   const notification = useToastContext()
//   const { user } = useContext(AuthContext)

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     clearErrors,
//     setError
//   } = useForm({ mode: 'onChange' })

//   const [category, setCategory] = useState('')

//   const onSubmit = async (data) => {
//     try {
//       const payload = {
//         formName: data.formName,
//         formType: data.formType,
//         category,
//         status: 'active'
//       }

//       const res = await apiPost(apiPath.addForm, payload)
//       if (res?.data?.success) {
//         notification.success(res?.data?.message)
//         getForms()
//         closeModal()
//       } else {
//         notification.error(res?.data?.message)
//       }
//     } catch (err) {
//       console.error('Add Form Error:', err)
//     }
//   }

//   const handleCategoryChange = (e) => {
//     if (e.target.value) {
//       setCategory(e.target.value)
//       clearErrors('category')
//     } else {
//       setCategory('')
//       setError('category', {
//         type: 'manual',
//         message: 'Please select a category.'
//       })
//     }
//   }

//   return (
//     <>
//       <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
//         <div className='relative w-auto my-6 mx-auto max-w-3xl'>
//           <div className='md:py-4 sm:px-2 sm:py-8 px-7'>
//             <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
//               {/* Header */}
//               <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
//                 <h3 className='text-xl font-semibold'>{t('ADD_FORM')}</h3>
//                 <button
//                   className='ml-auto flex items-center justify-center text-black border-2 rounded-full h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
//                   onClick={closeModal}
//                   title='Close'
//                 >
//                   <span className='text-[#B8BBBF] text-4xl' title='Close'>
//                     ×
//                   </span>
//                 </button>
//               </div>

//               {/* Body */}
//               <div className='flex-auto relative p-6'>
//                 <div className='grid sm:grid-cols-2 gap-4'>
//                   <div className='px-2'>
//                     <OInputField
//                       wrapperClassName='relative w-full z-0 group'
//                       type='text'
//                       name='formName'
//                       id='formName'
//                       inputLabel={
//                         <>
//                           {t('Title')}
//                           <span className='text-red-500'>*</span>
//                         </>
//                       }
//                       placeholder=''
//                       register={register('formName', formValidation.name)}
//                       errors={errors}
//                     />
//                   </div>

//                   <div className='px-2'>
//                     <OInputField
//                       wrapperClassName='relative w-full z-0 group'
//                       type='text'
//                       name='formType'
//                       id='formType'
//                       inputLabel={
//                         <>
//                           {t('TYPE')}
//                           <span className='text-red-500'>*</span>
//                         </>
//                       }
//                       placeholder=''
//                       register={register('formType', formValidation.name)}
//                       errors={errors}
//                     />
//                   </div>

//                   <div className='px-2'>
//                     <div className='relative w-full z-0 group'>
//                       <select
//                         id='category'
//                         className='dark:text-white block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none focus:outline-none peer'
//                         value={category}
//                         onChange={handleCategoryChange}
//                       >
//                         <option value=''>{t('SELECT_CATEGORY')}</option>
//                         <option value='onboarding'>{t('ONBOARDING')}</option>
//                       </select>
//                       <label
//                         className='absolute text-sm text-[#A5A5A5] transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8'
//                         htmlFor='category'
//                       >
//                         {t('CATEGORY')}
//                         <span className='text-red-500'>*</span>
//                       </label>
//                       <ErrorMessage message={errors?.category?.message} />
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Footer */}
//               <div className='border-t flex items-center justify-center p-6 border-solid border-slate-200 rounded-b'>
//                 <button
//                   onClick={closeModal}
//                   className='rounded mr-6 text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none transition-all duration-150'
//                   type='button'
//                 >
//                   {t('O_BACK')}
//                 </button>
//                 <button
//                   type='submit'
//                   className='px-8 py-2.5 bg-LightBlue text-white font-normal text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none transition-all duration-150'
//                   onClick={handleSubmit(onSubmit)}
//                 >
//                   {t('O_ADD')}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <div className='fixed opacity-25 inset-0 z-40 bg-black' />
//     </>
//   )
// }

// export default AddOnboarding;


import React, { useState, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import useToastContext from 'hooks/useToastContext'
import AuthContext from 'context/AuthContext'
import { apiPost } from 'utils/apiFetch'
import apiPath from 'utils/pathObj'
import ErrorMessage from 'components/ErrorMessage'
import OInputField from 'components/reusable/OInputField'
import formValidation from 'utils/formValidation'
import LiveFormPreview from './Preview'

const FIELD_TYPES = ['heading','input', 'radio', 'checkbox', 'date', 'file', 'select', 'textarea']

const AddOnboarding = ({ getForms, closeModal }) => {
  const { t } = useTranslation()
  const notification = useToastContext()
  const { user } = useContext(AuthContext)

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    setError,
    reset,
    watch,
  } = useForm({ mode: 'onChange' })

  const [category, setCategory] = useState('')
  const [customFields, setCustomFields] = useState([])
  const [fieldType, setFieldType] = useState('')
  const [fieldLabel, setFieldLabel] = useState('')
  const [fieldOptions, setFieldOptions] = useState('')
  const [fieldValues, setFieldValues] = useState({});

  const [alignment, setAlignment] = useState('');
  const [width, setWidth] = useState('');
  const [flexDirection, setFlexDirection] = useState('');
  const [customClass, setCustomClass] = useState('');
  const [dynamicFields, setDynamicFields] = useState([
    { fieldType: '', fieldLabel: '', fieldOptions: '', mandatory:false},
  ])
  

  const watchFields = watch();

  const formName = watch('formName');
  useEffect(() => {
    console.log('Form name changed:', formName);
  }, [formName]);
  
  const handleDynamicFieldChange = (index, key, value) => {
    setDynamicFields(prev => {
      const newFields = [...prev];
      newFields[index][key] = value;
      return newFields;
    });
  }
  
  const addDynamicFieldBlock = () => {
    setDynamicFields(prev => [...prev, { fieldType: '', fieldLabel: '', fieldOptions: '' , mandatory: false}]);
  }
  
  const handleAddField = () => {
    const newFields = dynamicFields.map(field => {
      const { fieldType, fieldLabel, fieldOptions, mandatory } = field;
  
      if (!fieldType || !fieldLabel.trim()) {
        notification.error('Please fill all field blocks with type and label');
        return null;
      }
  
      return {
        id: Date.now() + Math.random(),
        type: fieldType,
        label: fieldLabel.trim(),
        mandatory: mandatory || false,
        options: ['radio', 'select', 'checkbox'].includes(fieldType)
          ? fieldOptions.split(',').map(opt => opt.trim()).filter(opt => opt.length > 0)
          : [],
        styles: {
          container: `mb-4 flex ${flexDirection} ${width} ${alignment} ${customClass}`,
          label: `text-sm font-medium mr-2 ${alignment} ${width}`,
          input: `border border-gray-300 rounded-md shadow-sm p-1 ${width} ${alignment}`,
        },
        value: fieldType === 'checkbox' ? [] : '',
      };
    }).filter(Boolean);
  
    if (newFields.length !== dynamicFields.length) return;
  
    // Push as a group (array of fields)
    setCustomFields(prev => [...prev, newFields]);
  
    // Reset dynamic fields
    setDynamicFields([{ fieldType: '', fieldLabel: '', fieldOptions: '', mandatory: false }]);
    setAlignment('');
    setWidth('');
    setFlexDirection('');
    setCustomClass('');
  };
  

  const handleRemoveField = (id) => {
    setCustomFields(prev =>
      prev
        .map(group => group.filter(field => field.id !== id))
        .filter(group => group.length > 0) // Remove empty groups
    );
  
    setFieldValues(prev => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };
  
  const handleCategoryChange = (e) => {
    const val = e.target.value
    if (val) {
      setCategory(val)
      clearErrors('category')
    } else {
      setCategory('')
      setError('category', {
        type: 'manual',
        message: 'Please select a category.'
      })
    }
  }
      console.log(customFields, "custom fielsddd")

      
      const onSubmit = async (data) => {
        console.log("[1] Starting submit - original data:", { data, category, customFields });
      
        // 1. Validate required fields
        if (!category) {
          console.log("[2] Validation failed - missing category");
          setError('category', {
            type: 'manual',
            message: 'Please select a category.'
          });
          return;
        }
      
        // 2. Prepare FormData
        const formData = new FormData();
        console.log("[3] Created empty FormData");
      
        // 3. Clone customFields while preserving File objects
        console.log("[4] Original customFields structure:", customFields);
        
        const clonedCustomFields = customFields.map(row => 
          row.map(field => {
            console.log(`[5] Processing field ${field.id} (${field.type})`, field);
            
            if (field.type === 'file' && field.value instanceof File) {
              console.log("[6] Found file field with File object:", {
                fileName: field.value.name,
                fileType: field.value.type,
                fileSize: field.value.size
              });
              return {
                ...field,
                uploadKey: `file_${field.id}` // Add upload reference
              };
            }
            return {...field}; // Clone other fields normally
          })
        );
      
        console.log("[7] Cloned customFields with uploadKeys:", clonedCustomFields);
      
        // 4. Process files and append to FormData
        let fileCount = 0;
        clonedCustomFields.forEach(row => {
          row.forEach(field => {
            if (field.type === 'file' && field.value instanceof File) {
              console.log(`[8] Appending file ${field.uploadKey}:`, field.value);
              formData.append(field.uploadKey, field.value);
              fileCount++;
            }
          });
        });
      
        console.log(`[9] Appended ${fileCount} files to FormData`);
      
        // 5. Prepare clean version for JSON (without File objects)
        const fieldsForJson = clonedCustomFields.map(row => 
          row.map(field => {
            if (field.type === 'file') {
              const {value, ...rest} = field;
              console.log(`[10] Preparing file field ${field.id} for JSON (removed File object)`);
              return rest;
            }
            return field;
          })
        );
      
        console.log("[11] Final customFields for JSON:", fieldsForJson);
      
        // 6. Append other form data
        formData.append('formName', data.formName);
        formData.append('formType', data.formType);
        formData.append('category', category);
        formData.append('status', 'active');
        formData.append('customFields', JSON.stringify(fieldsForJson));
      
        console.log("[12] FormData contents before sending:");
        for (let [key, value] of formData.entries()) {
          console.log(
            key, 
            value instanceof File 
              ? `[File: ${value.name}, ${value.size} bytes, ${value.type}]` 
              : value
          );
        }
      
        // 7. Submit to API
        try {
          console.log("[13] Starting API submission...");
          const res = await apiPost(apiPath.addForm, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`[14] Upload progress: ${percentCompleted}%`);
            }
          });
      
          console.log("[15] API response received:", res.data);
      
          // 8. Handle response
          if (res?.data?.success) {
            console.log("[16] Submission successful");
            notification.success(res?.data?.message);
            closeModal();
          } else {
            console.error("[17] API returned error:", res?.data);
            notification.error(res?.data?.message || 'Submission failed');
          }
        } catch (err) {
          console.error("[18] Submission failed:", {
            error: err,
            response: err.response?.data,
            stack: err.stack
          });
          
          notification.error(
            err.response?.data?.message || 
            'An error occurred while saving the form'
          );
        }
      };
  
  return (
    <div className='justify-end items-start flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none pt-12 pr-10'>
                <div className='relative w-auto mx-auto max-w-7xl'>
                  <div className='md:py-4 sm:px-2 sm:py-8 px-7 ml-[133px]'>
                    <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[862px]'>
                    <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('ADD_FORM')}</h3>
                <button
                  className='ml-auto text-black border-2 rounded-full h-8 w-8 flex items-center justify-center outline-none focus:outline-none'
                  onClick={closeModal}
                  title='Close'
                >
                  <span className='text-[#B8BBBF] text-2xl'>×</span>
                </button>
              </div>
            {/* Body */}
            <form onSubmit={handleSubmit(onSubmit)} className='flex-auto relative p-6 grid grid-cols-2 gap-6'>

              {/* Left Column */}
              <div>
                <div className='grid sm:grid-cols-1 gap-4'>
                  <div className='px-2'>
                    <OInputField
                      type='text'
                      name='formName'
                      id='formName'
                      inputLabel={<>{t('Title')}<span className='text-red-500'>*</span></>}
                      register={register('formName', formValidation.name)}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                    <OInputField
                      type='text'
                      name='formType'
                      id='formType'
                      inputLabel={<>{t('TYPE')}<span className='text-red-500'>*</span></>}
                      register={register('formType', formValidation.name)}
                      errors={errors}
                    />
                  </div>
                  <div className='px-2'>
                    <div className='relative w-full z-0 group'>
                      <select
                        id='category'
                        className='block py-4 px-3 w-full text-sm border-2 rounded-lg border-[#DFDFDF]'
                        value={category}
                        onChange={handleCategoryChange}
                      >
                        <option value=''>{t('SELECT_CATEGORY')}</option>
                        <option value='onboarding'>{t('ONBOARDING')}</option>
                      </select>
                      <label className='absolute text-sm text-[#A5A5A5] transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10'>
                        {t('CATEGORY')}<span className='text-red-500'>*</span>
                      </label>
                      <ErrorMessage message={errors?.category?.message} />
                    </div>
                  </div>
                </div>
                {/* Custom Fields */}
                <div className='mt-6 border-t pt-6'>
                  <h4 className='font-medium mb-4'>{t('Add Custom Fields')}</h4>
                  {dynamicFields.map((field, index) => (
                    <div key={index} className='mb-4 border p-3 rounded'>
                      <div className='flex items-center mb-2 gap-2'>
                        <select
                          value={field.fieldType}
                          onChange={e => handleDynamicFieldChange(index, 'fieldType', e.target.value)}
                          className='border px-3 py-2 rounded w-[140px]'>
                          <option value=''>Select Type</option>
                          {FIELD_TYPES.map(type => (
                            <option key={type} value={type}>{type.toUpperCase()}</option>
                          ))}
                        </select>
                        <input
                          type='text'
                          placeholder='Field Label'
                          value={field.fieldLabel}
                          onChange={e => handleDynamicFieldChange(index, 'fieldLabel', e.target.value)}
                          className='border px-3 py-2 rounded w-[200px]'
                        />
                       <div className="flex flex-col items-center font-sm ml-1">
                        <label className="text-xs mb-1 text-center">Required</label>
                        <input
                          type="checkbox"
                          checked={field.mandatory}
                          onChange={(e) => handleDynamicFieldChange(index, 'mandatory', e.target.checked)}
                          className="h-4 w-4"
                        />
                      </div>
                      </div>
                      {['radio', 'select', 'checkbox'].includes(field.fieldType) && (
                        <div className='flex flex-col gap-1 mb-2'>
                          <label className='font-medium'>Options (comma separated)</label>
                          <input
                            type='text'
                            placeholder='e.g. Option1, Option2'
                            value={field.fieldOptions}
                            onChange={e => handleDynamicFieldChange(index, 'fieldOptions', e.target.value)}
                            className='border px-3 py-2 rounded w-[300px]'
                          />
                        </div>
                      )}
                    </div>
                  ))}
                  <button
                    type='button'
                    onClick={addDynamicFieldBlock}
                    className='bg-green-500 text-white px-4 py-2 rounded mt-2 mb-2'
                  >
                    Add Another Field
                  </button>
                  <div className="flex gap-4 items-center mb-4">
                  <div>
                  <label className="block mb-1 ml-2">Label Alignment</label>
                  <select
                    value={alignment}
                    onChange={(e) => setAlignment(e.target.value)}
                    className="border p-2 w-full"
                  >
                    <option value="">Set an Alignment</option>
                    <option value="justify-start">Left</option>
                    <option value="justify-center">Center</option>
                    <option value="justify-end">Right</option>
                  </select>
                </div>
                <div>
                <label className="block mb-1 ml-2">Width</label>
                <select value={width} onChange={(e) => setWidth(e.target.value)} className="border p-2 w-full">
                <option value="">Set a Width</option>
                  <option value="w-full">Full Width</option>
                  <option value="w-1/2">Half Width</option>
                  <option value="w-1/3">One Third</option>
                  <option value="w-1/4">One Fourth</option>
                </select>
                  </div>
                </div>
                <div>
                <div>
                  <label className="block mb-1">Flex Direction</label>
                  <select value={flexDirection} onChange={(e) => setFlexDirection(e.target.value)} className="border p-2 w-full">
                  <option value="">Set a Direction</option>
                    <option value="flex-col">Column</option>
                    <option value="flex-row">Row</option>
                  </select>
                </div>
                <div className="col-span-full mt-2">
                  <label className="block mb-1">Custom Class (Optional)</label>
                  <input value={customClass} onChange={(e) => setCustomClass(e.target.value)} className="border p-2 w-full" placeholder="e.g. justify-end items-end" />
                </div>
                </div>
                  <button
                    type='button'
                    onClick={handleAddField}
                    className='bg-blue-500 text-white px-4 py-2 rounded mt-2'>
                    Add Field
                  </button>
                </div>
              </div>
              <LiveFormPreview
                customFields={customFields}
                setCustomFields={setCustomFields}
                fieldValues={fieldValues}
                setFieldValues={setFieldValues}
                handleRemoveField={handleRemoveField}
              />
            </form>

            {/* Footer */}
            <div className='flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b gap-4'>
              <button
                className='bg-gray-500 text-white active:bg-gray-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none'
                type='button'
                onClick={closeModal}
              >
                Back
              </button>
              <button
                className='bg-blue-600 text-white active:bg-blue-800 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none'
                type='submit'
                onClick={handleSubmit(onSubmit)}
              >
                Save Form
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddOnboarding


